import React, { useState } from 'react';
import SuperAdminSidebar from './SuperAdminSidebar';
import ProviderRequests from './pages/ProviderRequests';
import EventsExhibitions from './pages/EventsExhibitions';
import SuperAdminCourseCategories from './pages/SuperAdminCourseCategories';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import SuperAdminCommission from './pages/SuperAdminCommission';
import CouponManagement from './pages/CouponManagement';
import Tickets from './pages/Tickets';
import BasicInformation from './pages/BasicInformation';
import Site from './pages/Site';
import Policies from './pages/Policies';
import API from './pages/API';
import Earnings from './pages/Earnings';
import WithdrawalRequests from './pages/WithdrawalRequests';
import CourseOrders from './pages/CourseOrders';
import TicketCategories from './pages/TicketCategories';
import { Menu, LogOut, Shield } from 'lucide-react';

const SuperAdminPanel = ({ authToken, onLogout }) => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [withdrawalFilter, setWithdrawalFilter] = useState('All');

  // Removed hardcoded withdrawal requests state
  const [withdrawalRequests, setWithdrawalRequests] = useState([]);

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <SuperAdminDashboard authToken={authToken} setActiveTab={setActiveTab} />;
      case 'provider-requests':
        return <ProviderRequests authToken={authToken} />;
      case 'coupons':
        return <CouponManagement authToken={authToken} />;
      case 'commission':
        return <SuperAdminCommission authToken={authToken} />;
      case 'events':
        return <EventsExhibitions authToken={authToken} />;
      case 'tickets':
        return <Tickets authToken={authToken} />;
      case 'ticket-categories':
        return <TicketCategories authToken={authToken} />;
      case 'course-orders':
        return <CourseOrders authToken={authToken} />;
      case 'earnings':
        return <Earnings
          authToken={authToken}
          setActiveTab={setActiveTab}
          setWithdrawalFilter={setWithdrawalFilter}
          withdrawalRequests={withdrawalRequests}
        />;
      case 'withdrawals':
        return <WithdrawalRequests
          authToken={authToken}
          initialFilter={withdrawalFilter}
        />;
      case 'course-categories':
        return <SuperAdminCourseCategories authToken={authToken} />;
      case 'basic-info':
        return <BasicInformation authToken={authToken} isSuperAdmin />;
      case 'site':
        return <Site authToken={authToken} isSuperAdmin />;
      case 'policies':
        return <Policies authToken={authToken} isSuperAdmin />;
      case 'api':
        return <API authToken={authToken} isSuperAdmin />;
      default:
        return (
          <div className="p-6">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Super Admin Dashboard</h2>
            <p className="text-gray-600">Select an option from the sidebar.</p>
          </div>
        );
    }
  };

  return (
    <div className="h-screen bg-gray-50 flex overflow-hidden">
      <SuperAdminSidebar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white shadow-sm border-b border-gray-200">
          <div className="flex items-center justify-between h-16 px-6">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => setSidebarOpen(true)}
                className="lg:hidden p-2 rounded-md hover:bg-gray-100"
              >
                <Menu className="w-5 h-5" />
              </button>
              <h1 className="text-xl font-bold text-gray-900">Tartalk Super Admin</h1>
              <span className="flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-100 text-indigo-800">
                <Shield className="h-3 w-3 mr-1" /> Super Admin
              </span>
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={() => {
                  if (window.confirm('Logout?')) onLogout();
                }}
                className="flex items-center space-x-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                title="Logout"
              >
                <LogOut className="h-4 w-4" />
                <span className="hidden sm:block">Logout</span>
              </button>
            </div>
          </div>
        </header>
        <main className="flex-1 p-6 overflow-y-auto">{renderContent()}</main>
      </div>
    </div>
  );
};

export default SuperAdminPanel;
